import { useState } from 'react';
import toast from 'react-hot-toast';
import { useAuth } from '../../hooks';
import { ApiError } from '../../utils/apiClient';
import { Alert } from '../common/Alert';
import { LoadingLabel } from '../common/Cursor';

export function VerifyEmailBanner() {
  const { user, loading, resendVerification } = useAuth();
  const [sending, setSending] = useState(false);

  if (loading || !user || user.emailVerified) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await resendVerification();
      toast.success('Verification email sent. Check your inbox.');
    } catch (err) {
      toast.error(err instanceof ApiError ? err.message : 'Failed to resend verification email');
    } finally {
      setSending(false);
    }
  };

  return (
    <Alert variant="warning" role="status" className="rounded-none border-x-0 justify-center py-2">
      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
        <span>Please verify your email address.</span>
        <button
          type="button"
          onClick={handleResend}
          disabled={sending}
          className="btn btn-xs btn-ghost underline"
        >
          {sending ? <LoadingLabel>Sending</LoadingLabel> : 'Resend email'}
        </button>
      </div>
    </Alert>
  );
}
